import { render, staticRenderFns } from "./LoginMsgCheck.vue?vue&type=template&id=6ed71cb8&scoped=true&"
import script from "./LoginMsgCheck.vue?vue&type=script&lang=ts&"
export * from "./LoginMsgCheck.vue?vue&type=script&lang=ts&"
import style0 from "./LoginMsgCheck.vue?vue&type=style&index=0&id=6ed71cb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed71cb8",
  null
  
)

export default component.exports